import RequireAuthentication from '@/router/guards/RequireAuthentication'
import { lazy } from 'react'

const KnowBeti = lazy(() => import('./pages/KnowBeti'))
const DASS21 = lazy(() => import('./pages/DASS21'))
const Result = lazy(() => import('./pages/Result'))

const BetiRoutes = [
  <RequireAuthentication path="/beti" key="/Beti" exact component={KnowBeti} />,
  <RequireAuthentication
    path="/beti/DASS-21"
    key="/beti/DASS-21"
    exact
    component={DASS21}
  />,
  <RequireAuthentication
    path="/beti/DASS-21/resultado"
    key="/beti/DASS-21/resultado"
    exact
    component={Result}
  />,
]

export default BetiRoutes
